<template>
  <div class="xcard">
    <div class="row">
      <div class="col-sm-5"> 
        <input class="btn btn-sm" type="file" id="fileUpload" />
      </div>
      <div class="col-sm-6">
        <input class="btn btn-sm btn-success" type="button" id="upload" value="Visualizar" @click="Upload()" />
      </div>
    </div>
    <hr />

    <div class="table-responsive">
      <table class="table table-condensed">
        <thead>
          <tr>
            <th> <small>Nro</small> </th>
            <th style="min-width:150px"> <small>Estado</small> </th>
            <th> <small>Documento</small> </th>
            <th> <small>Nombres</small> </th>
            <th> <small>Apellido_1</small> </th>
            <th> <small>Apellido_2</small> </th>
            <th> <small>Telefono</small> </th>
            <th> <small>Correo</small> </th>
            <th> <small>Genero</small> </th>
            <th> <small>Usuario Moodle</small> </th>
            <th> <small>Clave Moodle</small> </th>
            <th> <small>Departamento (Carnet)</small> </th>
            <th> <small>Profesion</small> </th>
            <th> <small>Ciudad Residencia</small> </th>

            <th> <small>Matricula</small> </th>
            <th> <small>Matricula fecha</small> </th>
            <th> <small>Colegiatura</small> </th>
            <th> <small>Colegiatura fecha</small> </th>
            <th> <small>Certificacion</small> </th>
            <th> <small>Certificacion fecha</small> </th>
            <th> <small>Cuotas</small> </th>
            <th> <small>Inscripcion</small> </th>
            <th> <small>Asesor</small> </th>
            <th> <small>Tipo</small> </th>
            <th> <small>Plan de pagos</small> </th>
          </tr>
        </thead>

        <tbody>
          <tr :key="ind" v-for="(e,ind) in estudiantes">
            <td> <small> {{ind+1}} </small> </td>
            <td> <small> {{e.estado}} </small> </td>
            <td> <small> {{e.num_doc}} </small> </td>
            <td> <small> {{e.nombres}} </small> </td>
            <td> <small> {{e.pri_apellido}} </small> </td>
            <td> <small> {{e.seg_apellido}} </small> </td>
            <td> <small> {{e.telefono1}} </small> </td>
            <td> <small> {{e.email}} </small> </td>
            <td> <small> {{e.sexo}} </small> </td>
            <td> <input type="text" v-model="e.usuario_moodle" style="border: 0;"> </td>
            <td> <input type="text" v-model="e.clave_moodle" style="border: 0;"> </td>
            <td> <small> {{e.iddepartamento}} </small> </td>
            <td> <small> {{e.profesiones[0]}} </small> </td>
            <td> <small> {{e.idciudad}} </small> </td>

            <td class="text-primary"> <small> {{e.matricula}} Bs. </small> </td>
            <td> <small> {{e.matricula_f}} </small> </td>
            <td class="text-primary"> <small> {{e.colegiatura}} Bs. </small> </td>
            <td> <small> {{e.colegiatura_f}} </small> </td>
            <td class="text-primary"> <small> {{e.certificacion}} Bs. </small> </td>
            <td> <small> {{e.certificacion_f}} </small> </td>
            <td class="text-primary"> <small> {{e.cuotas}} </small> </td>
            <td> <small> {{e.fecha_registro}} </small> </td>
            <td> <small> {{e.idasesor}} </small> </td>
            <td> <small> {{e.tipoins}} </small> </td>
            <td>
              <button v-if="e.plan.length" type="button" class="btn btn-link" data-toggle="modal" data-target="#planPagos" @click="planPagos(e)"> <span class="glyphicon glyphicon-calendar"></span> </button>
            </td>
          </tr>
        </tbody>
      </table>

      <button v-if="estudiantes.length>0" :disabled="subiendo" class="btn btn-sm btn-azul" @click="subir()"> Subir estudiantes </button>
    </div>
    <p class="text-center text-info"> <small>{{msg}}</small> </p>
    <Codigos id="codigos" :obj="modeldatos"/>
    <PlanPagos :cuotas="plan.cuotas" :cole="plan.monto_colegiatura" :cuotas_validas="cuotas_validas"/>
    <div id="dvExcel">
    </div>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import PlanPagos from '@/components/AVer-cuotas.vue'
import { parseJsonError,getCleanedString,isNullObject } from '@/components/Utils.js'
import Codigos from '@/components/AExcelInsCodigos.vue'

export default {
  //props:{ programa:{type:Object,required:true} },
  data(){
    return{
      modeldatos: {xtitle:'',xbody:'',xsql:''},
      subiendo: false,
      msg:'',
      programa:{},
      estudiantes:[],
      getCiudades:[],
      getProfesiones:[],
      getDepartamentos:[],
      cuotas_validas:{},

      plan:{ cuotas:[],monto_colegiatura:-1,cuotas_validas:[] },
    }
  },
  components:{ PlanPagos,Codigos },
  methods:{
    crearLogin( a, ap, am ){
      var inicial = "";
      var aa = "";
      var mm = "";
      if( a && a.length > 0 ){ inicial = a.substring(0,1); }
      if( ap && ap.length > 0 ){ aa = ap.replace(/\s+/g, ""); }
      if( am && am.length > 0 ){ mm = am.replace(/\s+/g, ""); }
      var logi = inicial + aa+ mm;
      logi = getCleanedString(logi);
      return logi;
    },
    crearClave( car,dep ){
      var ci = "";
      if( car && car.length > 0 ) ci = car;
      if( dep ) ci = ci+dep.extension;
      return ci;
    },
    Upload() {
      var vue = this;
        var fileUpload = document.getElementById("fileUpload");
 
        var regex = /^([a-zA-Z0-9\s_\\.\-:])+(.xls|.xlsx)$/;
        if (regex.test(fileUpload.value.toLowerCase())) {
            if (typeof (FileReader) != "undefined") {
                var reader = new FileReader();
 
                //For Browsers other than IE.
                if (reader.readAsBinaryString) {
                    reader.onload = function (e) {
                        vue.processExcel(e.target.result);
                    };
                    reader.readAsBinaryString(fileUpload.files[0]);
                } else {
                    //For IE Browser.
                    reader.onload = function (e) {
                        var data = "";
                        var bytes = new Uint8Array(e.target.result);
                        for (var i = 0; i < bytes.byteLength; i++) {
                            data += String.fromCharCode(bytes[i]);
                        }
                        vue.processExcel(data);
                    };
                    reader.readAsArrayBuffer(fileUpload.files[0]);
                }
            } else {
                alert("This browser does not support HTML5.");
            }
        } else {
            alert("Por favor seleccione un archivo excel valido.");
        }
    },
    strFeccha( f ){
      var c = new Date(f);
      var d = c.getDate();
      var m = c.getMonth()+1;
      var a = c.getFullYear();
      if( d < 10 ) d = '0'+d;
      if( m < 10 ) m = '0'+m;
      return d+'-'+m+'-'+a;
    },
    processExcel(data) {
      var vue = this;
        var workbook = window.XLSX.read(data, {
            type: 'binary'
        });
 
        var firstSheet = workbook.SheetNames[0];
        var excelRows = window.XLSX.utils.sheet_to_row_object_array(workbook.Sheets[firstSheet]);
 
          for (var i = 0; i < excelRows.length; i++) {
            window.console.log(  excelRows[i] )
            var nro = excelRows[i].Nro;
            var doc = excelRows[i].documento;
            var nom = excelRows[i].nombres.trim();
            var ap1 = excelRows[i].apellido1.trim();
            var ap2 = excelRows[i].apellido2?excelRows[i].apellido2.trim():"";
            var tel = excelRows[i].telefono1.trim();
            var ema = excelRows[i].email.trim();
            var gen = excelRows[i].genero.trim();
            var depastr = excelRows[i].departamento;
            var profstr = excelRows[i].profesion;
            var ciudstr = excelRows[i].ciudad_residencia;

            var matricula = parseInt(excelRows[i].matricula);
            var matricula_fecha = excelRows[i].matricula_fecha;
            var colegiatura = parseInt(excelRows[i].colegiatura);
            var colegiatura_fecha = excelRows[i].colegiatura_fecha; // fecha pevista
            var certificacion = parseInt(excelRows[i].certificacion);
            var certificacion_fecha = excelRows[i].certificacion_fecha;
            var fecha_registro = excelRows[i].fecha_registro;
            var cuotas = excelRows[i].cuotas;
            var idasesor = excelRows[i].idasesor;

            matricula_fecha = this.strFeccha(matricula_fecha);
            colegiatura_fecha = this.strFeccha(colegiatura_fecha);
            certificacion_fecha = this.strFeccha(certificacion_fecha);
            fecha_registro = this.strFeccha(fecha_registro);

            var depa = vue.getDepartamentos.find( x => x.nombre == depastr)
            var prof = vue.getProfesiones.find( x => x.nombre == profstr)
            var ciud = vue.getCiudades.find( x => x.nombre == ciudstr)
            var strs = matricula_fecha.includes('-')?matricula_fecha.split('-'):matricula_fecha.split('/');
            matricula_fecha = strs[2]+'-'+strs[1]+'-'+strs[0];

            strs = certificacion_fecha.includes('-')?certificacion_fecha.split('-'):certificacion_fecha.split('/');
            certificacion_fecha = strs[2]+'-'+strs[1]+'-'+strs[0];

            strs = colegiatura_fecha.includes('-')?colegiatura_fecha.split('-'):colegiatura_fecha.split('/');
            colegiatura_fecha = strs[2]+'-'+strs[1]+'-'+strs[0];
            if( !idasesor ) idasesor = this.$store.state.DATA_USER.id;

            var iddepa = -1;
            var idprof = -1;
            var idciud = -1;
            if( depa ) iddepa = depa.codigo;
            if( prof ) idprof = prof.codigo;
            if( ciud ) idciud = ciud.codigo;
            var login = this.crearLogin( nom,ap1,ap2 )
            var clave = this.crearClave( doc,depa )
            var plan = [];

            var est = {
                nro:nro,num_doc:doc,nombres:nom,pri_apellido:ap1,
                seg_apellido:ap2,telefono1:tel,email:ema,sexo:gen,
                usuario_moodle: login, clave_moodle: clave,
                tipo:"E",diestro:true,profesiones:[idprof],idciudad:idciud,iddepartamento:iddepa,
                matricula:matricula,certificacion:certificacion,colegiatura:colegiatura,
                matricula_f:matricula_fecha,certificacion_f:certificacion_fecha,colegiatura_f:colegiatura_fecha, 
                cuotas: cuotas, tipoins: cuotas?"INSCRIPCION":"PRE INSCRIPCION", plan:plan,
                idasesor: idasesor,
                estado:"SUBIR"
            }; 

            if( cuotas && cuotas == 0 ) cuotas = null; 
            if( cuotas ){
              plan = this.generarPlanCuotas( est );
              est.plan = plan;
            }
            if( fecha_registro ){
              var ss = fecha_registro.includes('-')?fecha_registro.split('-'):fecha_registro.split('/');
              fecha_registro = ss[2]+'-'+ss[1]+'-'+ss[0];
              est.fecha_registro = fecha_registro;
            }
  
            vue.estudiantes.push( est );
        }

        window.console.log( vue.estudiantes )
    },
    async subir(){
      this.subiendo = true;
      var vue = this;
      this.estudiantes.forEach( async function(e,i){
        e.estado = "SUBIENDO...";
        await vue.enviarDatos( e,i );
      })
    },
    async preCargar(){ 
      this.msg = 'Conectando...';
      var sql = gql`query{
        getCiudades{nombre id departamento{nombre} }
        getDepartamentos{nombre id extension}
        getProfesiones{id nombre}
      }`;
      this.$apollo.query({
        query: sql,
      }).then((data) => {
        var datas1 = [];
        var datas2 = [];
        var datas3 = [];
        data.data.getCiudades.forEach( function(e){
          if( !e.departamento ) e.departamento = {nombre:''};
          e.nombre = e.nombre+' ('+e.departamento.nombre+')';
          datas1.push( {nombre:e.nombre,codigo:e.id} );
        })
        data.data.getProfesiones.forEach( function(e){
          datas2.push( {nombre:e.nombre,codigo:e.id} );
        })
        data.data.getDepartamentos.forEach( function(e){
          datas3.push( {nombre:e.nombre,codigo:e.id,extension:e.extension} );
        })
        this.getCiudades = datas1;
        this.getProfesiones = datas2;
        this.getDepartamentos = datas3;
        //window.console.log( datas1,datas2,datas3 );
        this.msg = '';

      }).catch((error) => {
        window.console.error(error);
        this.msg = error;
      })
    },
    async enviarDatos( estudiante,indice ){
      var obj = window.Object.assign({},estudiante);
      if( !obj.seg_apellido ) delete obj.seg_apellido
      delete obj.nro;
      delete obj.estado;
      delete obj.tipoins;
      delete obj.matricula;
      delete obj.certificacion;
      delete obj.colegiatura;
      delete obj.matricula_f;
      delete obj.certificacion_f;
      delete obj.colegiatura_f;
      delete obj.cuotas;
      delete obj.plan;
      delete obj.idasesor;
      delete obj.fecha_registro;

      this.subiendo = true;
      var vue = this;
      var sql = gql`mutation{ createPersona(input:${window.stringifyObject(obj)}){ok,persona{id,num_doc,nombres,pri_apellido,seg_apellido},errors{message}} }`;
      vue.msg = '';
      window.console.log( sql );

      await this.$apollo.mutate({
        mutation: sql,
      }).then((data) => {
        if(data.data.createPersona.ok){
          window.console.log( data.data.createPersona )
          var es = vue.estudiantes.find( x => x.num_doc == obj.num_doc )
          if( es ) {
            es.estado = "SUBIDO, inscribiendo...";
            if( es.cuotas ) vue.realizarInscripcion( data.data.createPersona.persona.id,es )
            else vue.realizarPreInscripcion( data.data.createPersona.persona.id,es )
          }
        }else{
          var errores = JSON.stringify(data.data.createPersona.errors);
          var ob = JSON.parse( errores );
          var vals = '';
          ob.forEach(function(k){ vals += Object.values(k)+"-\n\t"; });
          vue.msg = '';
          //vue.subiendo = false;
          var est = vue.estudiantes.find( x => x.num_doc == obj.num_doc )
          if( est ) {
            est.estado = vals;
            if( vals.includes("documento ya fue registrado") ) vue.buscarEstudianteYaRegistrado( est )
          }
          window.console.log( obj,vals )
        }

        if( indice == vue.estudiantes.length -1 ){
          vue.subiendo = false;
        }

      }).catch((error) => {
        if( !error ) return;
        //this.subiendo = false;
        window.console.error(JSON.stringify(error));
        this.$notify( parseJsonError( error ) )
        var est = vue.estudiantes.find( x => x.num_doc == obj.num_doc )
        if( est ) est.estado = error;
      })
    },
    async buscarEstudianteYaRegistrado( estudiante ){
      var vue = this;
      window.console.log( "buscarEstudianteYaRegistrado >>>>>",estudiante )
      var sql = gql`query{ getPersonasByDoc(num_doc:"${+estudiante.num_doc}"){ id num_doc nombres pri_apellido } }`;
      // window.console.log( "BUSCANDO EST",sql )
      await this.$apollo.query({
        query: sql,
      }).then((data) => {
        var res = data.data.getPersonasByDoc;
        // window.console.log( "ENCONTRADOS: ",res," PARA:: ",estudiante.num_doc ) // no encuentra??? 
        var es = vue.estudiantes.find( x => x.num_doc == estudiante.num_doc )
        if( res.length == 1 ){
          if( es ) {
            var person = res[0]
            es.estado = "INSCRIBIENDO>>>.";
            window.console.log( "yA REGISTRADO:::::::::",person )
            if( es.cuotas ) vue.realizarInscripcion( person.id,es )
            else vue.realizarPreInscripcion( person.id,es )
          }
        }else if( res.length > 1 ){
          es.estado = "MAS DE UN ESTUDIANTE COINCIDE CON ESTE CARNET, Isncribalo manualmente";
        }else{
          es.estado = "Hay un usuario(personal de la empresa) con el mismo carnet";
        }

      }).catch((error) => {
        if( !error ) return;
        window.console.error(JSON.stringify(error));
        this.$notify( parseJsonError( error ) )
        var est = vue.estudiantes.find( x => x.num_doc == estudiante.num_doc )
        if( est ) est.estado = error;
      })
    },

    async realizarPreInscripcion( idestudiante,estudiante ){
      var vue = this; 
      var dat = {
        idprograma: this.programa.id,
        idestudiante: idestudiante,
        idasesor: estudiante.idasesor,
        monto_matricula: estudiante.matricula,
        monto_colegiatura: estudiante.colegiatura,
        monto_certificacion: estudiante.certificacion,
      }
      if( estudiante.fecha_registro ) dat.fecha_registro = estudiante.fecha_registro;
      var sql = gql`
        mutation{
          createPreInscripcion(input:${window.stringifyObject(dat)}){ok inscripcion{id} errors{message}}
        }
      `;

      window.console.log( "PRE INSCRIBIENDO: >>>>>",sql )

      await this.$apollo.mutate({
        mutation: sql,
      }).then((data) => {
        if(data.data.createPreInscripcion.ok){
          window.console.log( data.data.createPreInscripcion )
          var es = vue.estudiantes.find( x => x.num_doc == estudiante.num_doc )
          if( es ) es.estado = "PRE INSCRITO.";
        }else{
          var errores = JSON.stringify(data.data.createPreInscripcion.errors);
          var ob = JSON.parse( errores );
          var vals = '';
          ob.forEach(function(k){ vals += Object.values(k)+"-\n\t"; });
          vue.msg = '';
          var est = vue.estudiantes.find( x => x.num_doc == estudiante.num_doc )
          if( est ) est.estado = vals;
          window.console.log( "ERROR: CREATE PREINSss",estudiante,vals )
        }

      }).catch((error) => {
        if( !error ) return;
        window.console.error(JSON.stringify(error));
        this.$notify( parseJsonError( error ) )
        var est = vue.estudiantes.find( x => x.num_doc == estudiante.num_doc )
        if( est ) est.estado = error;
      })
    },
    async realizarInscripcion( idestudiante,estudiante ){ 
      var vue = this; 
      var cuotas = estudiante.plan; 
      //cuotas = window.stringifyObject(cuotas);
      var dat = {
        idprograma:this.programa.id,
        idestudiante:idestudiante,
        idasesor:estudiante.idasesor,
        tipopago:true,
        matricula:{ monto:estudiante.matricula,fecha:estudiante.matricula_f} ,
        certificacion:{ monto:estudiante.certificacion,fecha:estudiante.certificacion_f} ,
        cuotas: cuotas,
      }
      if( estudiante.fecha_registro ) dat.fecha_registro = estudiante.fecha_registro;

      var sql = gql`
        mutation{
          createInscripcion(input:${window.stringifyObject(dat)}){ok inscripcion{id} errors{message}}
        }
      `;

      window.console.log( "INSCRIBIENDO: >>>>>",sql )

      await this.$apollo.mutate({
        mutation: sql,
      }).then((data) => {
        if(data.data.createInscripcion.ok){
          window.console.log( data.data.createInscripcion )
          var es = vue.estudiantes.find( x => x.num_doc == estudiante.num_doc )
          if( es ) es.estado = "INSCRITO.";
        }else{
          var errores = JSON.stringify(data.data.createInscripcion.errors);
          var ob = JSON.parse( errores );
          var vals = '';
          ob.forEach(function(k){ vals += Object.values(k)+"-\n\t"; });
          vue.msg = '';
          var est = vue.estudiantes.find( x => x.num_doc == estudiante.num_doc )
          if( est ) est.estado = vals;
          window.console.log( "ERROR: CREATE INSss",estudiante,vals )
        }

      }).catch((error) => {
        if( !error ) return;
        window.console.error(JSON.stringify(error));
        this.$notify( parseJsonError( error ) )
        var est = vue.estudiantes.find( x => x.num_doc == estudiante.num_doc )
        if( est ) est.estado = error;
      })
    },
    generarPlanCuotas( estudiante ){
      var mensualidad = Math.trunc( Math.ceil(estudiante.colegiatura / estudiante.cuotas) );
      var cole = parseInt(estudiante.colegiatura);
      var cuos = [];
      var nro = 1;
      var fecha = new Date( estudiante.colegiatura_f );
      var srtf = "";
      while( cole-mensualidad > 0 ){
        var ani = fecha.getFullYear();
        var mes = fecha.getMonth()+1;
        var dia = fecha.getDate()+1;
        if( mes < 10 ) mes = '0'+mes;
        if( dia < 10 ) dia = '0'+dia;
        cole = cole - mensualidad;
        srtf = ani+"-"+mes+"-"+dia;
        fecha.setMonth( mes );
        fecha.setDate( 15 );
        cuos.push( {monto:mensualidad,nro_cuota:nro,fecha:srtf} );
        nro += 1;
      }
      if(cole>0){
        ani = fecha.getFullYear();
        mes = fecha.getMonth()+1;
        dia = fecha.getDate();
        if( mes < 10 ) mes = '0'+mes;
        if( dia < 10 ) dia = '0'+dia;
        srtf = ani+"-"+mes+"-"+dia;
        fecha.setMonth( mes );
        fecha.setDate( 15 );
        cuos.push( {monto:cole,nro_cuota:nro,fecha:srtf} );
      }
      return cuos;
    },
    planPagos( est ){
      this.plan.cuotas = est.plan;
      this.plan.monto_colegiatura = est.colegiatura;
      //window.console.log( window.stringifyObject(est.plan) )
    },
  },
  mounted(){
    if( sessionStorage.xprograma != undefined ) {
      var ob1 = JSON.parse(sessionStorage.xprograma);
      if( !isNullObject(ob1) ) this.programa = ob1;
      window.console.log( "PROGRAMA EXCELLLL: ",this.programa )
    }
    this.preCargar();
  }
}
</script>